import React, { useEffect, useState, useCallback } from 'react';
import { apiService } from '../../../components/Config/api.service';
import TableList from '../../../components/Tools/TableList';
import { formatMoney } from '../../../components/Utils/FormatUtils';
import { FiDownload } from 'react-icons/fi';

const columns = [
    { key: 'employee', label: 'Employé', render: row => row.employee?.name || '' },
    { key: 'contract_type', label: 'Type de contrat', render: row => <span className="badge bg-[--bg-color] text-[--color-primary]">{row.contract_type}</span> },
    { key: 'worked_days', label: 'Jours travaillés' },
    { key: 'net_salary', label: 'Net à payer', render: row => formatMoney(row.net_salary) },
    { key: 'taxes', label: 'Impôts', render: row => formatMoney(row.taxes) },
    { key: 'salary', label: 'Salaire brut', render: row => formatMoney(row.salary) },
];

const ExternalPayslipsMonthly = ({ selectedMonth }) => {
    const [contracts, setContracts] = useState([]);
    const [pagination, setPagination] = useState({ total_count: 0, offset: 0, limit: 10, total_pages: 1, page: 1 });
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filterBy, setFilterBy] = useState({});
    const [selectedIds, setSelectedIds] = useState([]);

    // Parse selectedMonth "YYYY-MM"
    const [year, month] = selectedMonth.split('-');

    const fetchContracts = useCallback((page = 1, search = '', filter = {}) => {
        setLoading(true);
        const offset = (page - 1) * (pagination.limit || 10);

        // Préparer les paramètres de requête
        const params = new URLSearchParams();
        params.append('month', month);
        params.append('year', year);
        params.append('offset', offset);
        params.append('limit', pagination.limit || 10);
        if (search) params.append('search', search);
        if (filter && Object.keys(filter).length > 0) params.append('filter_by', JSON.stringify(filter));

        apiService.getElement(`/external_contracts/monthly?${params.toString()}`)
            .then(res => {
                setContracts(res.data.contracts || []);
                setPagination({
                    ...res.data.pagination,
                    page: page,
                });
            })
            .finally(() => setLoading(false));
    // eslint-disable-next-line
    }, [month, year, pagination.limit]);

    useEffect(() => {
        fetchContracts(1, searchQuery, filterBy);
    }, [selectedMonth, fetchContracts]);

    // Gestion du changement de page, recherche et filtre
    const handlePageChange = (page, search, filter) => {
        const newSearch = search !== undefined ? search : searchQuery;
        const newFilter = filter !== undefined ? filter : filterBy;
        setSearchQuery(newSearch);
        setFilterBy(newFilter);
        fetchContracts(page, newSearch, newFilter);
    };

    const exportToExcel = async () => {
        const params = new URLSearchParams();
        params.append('month', month);
        params.append('year', year);
        if (searchQuery) params.append('search', searchQuery);
        if (filterBy && Object.keys(filterBy).length > 0) params.append('filter_by', JSON.stringify(filterBy));
        if (selectedIds.length > 0) params.append('ids', JSON.stringify(selectedIds));

        const res = await apiService.getElement(`/external_contracts/monthly/export?${params.toString()}`);
        if (res.data && res.data.file && res.data.filename) {
            const link = document.createElement('a');
            link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.file}`;
            link.download = res.data.filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    };

    return (
        <div className="">
            <TableList
                columns={columns}
                data={contracts}
                loading={loading}
                pagination={pagination}
                onPageChange={handlePageChange}
                searchDisplay={true}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                filterBy={filterBy}
                setFilterBy={setFilterBy}
                showFilter={true}
                model="excohsp.external_contract"
                selectable={true}
                onSelectedRowsChange={setSelectedIds}
                selectActions={() => (
                    <button onClick={exportToExcel} className="btn btn-sm btn-outline hover:bg-[--color-primary]" disabled={selectedIds.length === 0}>
                        <FiDownload /> Exporter vers Excel
                    </button>
                )}
            />
        </div>
    );
};

export default ExternalPayslipsMonthly;